import { render } from "./ModalComunityInv.vue?vue&type=template&id=f225d88a&scoped=true"
import script from "./ModalComunityInv.vue?vue&type=script&lang=js"
export * from "./ModalComunityInv.vue?vue&type=script&lang=js"

import "./ModalComunityInv.vue?vue&type=style&index=0&id=f225d88a&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f225d88a"]])

export default __exports__